import { render, staticRenderFns } from "./DlgTrainingTemplateDelete.vue?vue&type=template&id=9be03fb0&scoped=true"
import script from "./DlgTrainingTemplateDelete.vue?vue&type=script&lang=ts"
export * from "./DlgTrainingTemplateDelete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be03fb0",
  null
  
)

export default component.exports